import {useMemo} from "react";
import {SpeakerType, useRoomConfig} from "../RoomConfigContext";
import {useSeatConfig} from "../SeatConfigContext";
import {getMaximumOffset} from "../utils/speakerUtils";
import {getOppositeLength} from "../utils/trig";
import {useScreenConfig} from "../ScreenConfigContext";

// ceiling speakers don't use the regular constraint / validation ruleset. Instead, their positions are entirely
// calculated before validation
export const useFrontSpeakers = (config, builtInWall, speakerType) => {
    const {width} = useRoomConfig();
    const {primaryEarPosition} = useSeatConfig();
    const {screenSize, acousticTransparent} = useScreenConfig();

    return useMemo(() => {
        // try the widest angle (30) to prevent overlap with screen
        let angle, x, y = 0, z;

        if (builtInWall)
            y = primaryEarPosition[1] - config.speakerOffset[1];

        if (speakerType === SpeakerType.Waterfall) {
            z = -config.size[2] * 0.4;
            // y = 100;
            x = 2.0 * config.size[0];
            angle = Math.PI;
        }
        else {
            if (builtInWall) {
                z = -config.size[2] * .5;
            }
            else {
                // use the diagonal as the minimum offset to walls
                const maxW = getMaximumOffset(config.size) * .5;
                z = -maxW;
            }

            const d = -primaryEarPosition[2] - (-z);

            // place behind screen with 15cm margin
            if (builtInWall && acousticTransparent) {
                x = screenSize * .5 - config.size[0] * .5 - 15;
            }
            else {
                const maxX = width * .5 - config.size[0] * 1.1; // Had to set this to 1.1 to make it visually more correct
                x = getOppositeLength(d, 30);
                x = Math.min(x, maxX);
            }

            angle = builtInWall? Math.PI: -Math.atan2(x, -d);
        }

        return [
            {
                position: [x, y, z],
                rotation: angle
            },
            {
                position: [-x, y, z],
                rotation: -angle
            }
        ];
    }, [speakerType, config, builtInWall, acousticTransparent, primaryEarPosition, screenSize, width]);
}
